module.exports = __webpack_public_path__ + "static/media/56.45ca5af1.mp3";